export default class Video {
  constructor() {
    this.$els = document.querySelectorAll(".js-video");

    this.$els.forEach(($el) => {
      const $playBtn = $el.querySelector(".js-video-play");
      const $video = $el.querySelector(".js-video-iframe");
      const $img = $el.querySelector(".js-video-image");
      const $overlay = $el.querySelector(".js-video-overlay");

      $playBtn.addEventListener("click", () => {
        const videoCode = $playBtn.dataset.video;

        $video.classList.remove("hidden");
        $img.classList.add("hidden");
        $playBtn.classList.add("hidden");
        $overlay.classList.add("hidden");

        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(videoCode, "text/html");
        const iframe = htmlDoc.querySelector("iframe");

        iframe.src = `${iframe.src}?autoplay=1&rel=0`;

        $video.appendChild(iframe);
      });
    });
  }
}
